module.exports = __webpack_public_path__ + "static/ForestBossA-d2331779647070ce1b3db4e94b384ddb.gif";